import { useState } from 'react';

import Button from '../Button';
import { CheckMarkIcon, CopyIcon } from '../../icons';
import OverlayTriggerTooltip from '../OverlayTriggerTooltip';

import styles from './_index.module.scss';

export interface CopyToClipboardProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  'data-testid'?: string;
  text?: string;
  value: string;
}

const CopyToClipboard = ({
  'data-testid': dataTestId = 'copy-to-clipboard',
  text = '',
  value,
  ...props
}: CopyToClipboardProps) => {
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);

  const handleClick = () => {
    setIsCopiedToClipboard(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => setIsCopiedToClipboard(false), 2000);
  };

  return (
    <OverlayTriggerTooltip
      aria-label="Copy"
      content={isCopiedToClipboard ? '' : 'Copy to clipboard'}
    >
      <Button
        className={styles[`copy-to-clipboard`]}
        data-testid={dataTestId}
        icon={isCopiedToClipboard ? <CheckMarkIcon /> : <CopyIcon />}
        isDisabled={isCopiedToClipboard}
        onClick={handleClick}
        text={text}
        variant="secondary"
        {...props}
      />
    </OverlayTriggerTooltip>
  );
};

export default CopyToClipboard;
